import http from '@/api/http'
import { ElMessage } from 'element-plus';

/*获取层级信息列表*/
export const getCompanyLevelList = (fn) => {
	return fn(['一层级', '二层级', '三层级', '四层级'])
}
/*获取分公司信息列表*/
export const getCompanyList = (fn) => {
	http.get('/npdp/base/get-company-info-list', {}).then(response => {
		if (response.code == '2001') {
			return fn(response.data)
		}
	})
}
/*角色管理-账户类型下拉列表*/
export const getAccountTypeList = (fn) => {
	http.get('/npdp/management/get-account-type-list', {}).then(response => {
		if (response.code == '2001') {
			return fn(response.data)
		}
	})
}
/*成员管理-角色下拉列表查询*/
export const getRoleList = (fn) => {
	http.get('/npdp/management/select-role-list', {}).then(response => {
		if (response.code == '2001') {
			return fn(response.data)
		}
	})
}
/*成员管理-邮箱模糊匹配*/
export const getEmailVagueMatch = (email, fn) => {
	http.post('/npdp/management/email-vague-match', {
		userEmail: email
	}).then(response => {
		if (response.code == '2001') {
			return fn(response.data)
		}
	})
}
/*成员管理-条线下拉列表查询*/
export const getProductLines = (fn) => {
	http.get('/npdp/base/get-product-lines', {}).then(response => {
		if (response.code == '2001') {
			return fn(response.data)
		}
	})
}

/* 下载报表 */
export const downloadReportExcel = (url, option, name) => {
	// ElMessage('准备中，请稍后')
	http.post(url, option).then(response => {
		let filename = response.headers['content-disposition']
		let index = filename.indexOf('=')
		if( index>0 ){
			name = decodeURIComponent(filename.substr(index+1))
		}
		const elink = document.createElement('a');
		elink.download = name;
		elink.style.display = 'none';
		const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		elink.href = URL.createObjectURL(blob);
		document.body.appendChild(elink);
		elink.click();
		document.body.removeChild(elink);
	})
	.catch(error => {
		ElMessage({
			type: 'error',
			message: error,
			showClose: true
		});
		console.error('Error occurred during report download:', error);
	});
}